import axios from "axios";
export const state = {
    setting: [],
    save: false,
    notifications: [],
};
export const getters = {
    Settings: state => state.setting.data,
    RoleNotifications: state => state.notifications.data,
    SAVING: state => state.save,
};

export const mutations = {
    SET_SAVING(state, newValue) {
        state.save = newValue;
    },
    SET_SETTINGS(state, newValue) {
        state.setting = newValue;
    },
    SET_NOTIFICATIONS(state, newValue) {
        state.notifications = newValue;
    },
};

export const actions = {
    updateSettings({ dispatch, commit }, data) {
        commit('SET_SAVING', true)
        axios.put(`general_settings/${data.id}`, data).then(response => {
            commit('SET_SAVING', false)
            dispatch('fetchSettings')
            if (response.status==200){
                let message = { 'msg': "Setting updated successfully" }
                dispatch('notification/success', message, { root: true })
            }
        }).catch(()=>{
            commit('SET_SAVING', false)
            let message = { 'msg': "Failed to update setting" }
            dispatch('notification/error', message, { root: true })
        })
    },
    updateRoleNotifications({ dispatch, commit }, data) {
        commit('SET_SAVING', true)
        axios.put(`role_notifications/${data.role}`, data).then(response => {
            commit('SET_SAVING', false)
            dispatch('fetchRoleNotifications')
            if (response.status==200){
                let message = { 'msg': "Setting updated successfully" }
                dispatch('notification/success', message, { root: true })
            }
        }).catch(()=>{
            commit('SET_SAVING', false)
            let message = { 'msg': "Failed to update setting" }
            dispatch('notification/error', message, { root: true })
        })
    },

    fetchSettings({ commit }) {
        axios.get('general_settings').then(setting => {
            commit('SET_SETTINGS', setting.data)
        })
    },
    fetchRoleNotifications({ commit }) {
        axios.get('role_notifications').then(notif => {
            commit('SET_NOTIFICATIONS', notif.data)
        })
    },

};